import { Col, Row, Accordion, Form } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { baseServices, useAiContext } from '../../context/AiContext';
import { useEffect, useState } from 'react';
import './AiQuotation.scss';
import { getCheckedServices } from '../../utils/quicko';
import { clone, cloneDeep } from 'lodash';

interface CustomToggleProps {
	children: React.ReactNode;
	eventKey: string;
	checked?: boolean;
	disabled?: boolean;
	txtButton: string;
	flag?: string;
	data?: any;
	setIsGommeAccordionOpen?: any;
	setIsAssicurazineRcOpen?: any;
	setIsAssicurazioneKaskoOpen?: any;
	setIsFurtoIncendioOpen?: any;
	setIsVetturaSostitutivaOpen?: any;
}

const CustomToggle = ({
	children,
	eventKey,
	disabled = false,
	checked,
	txtButton,
	flag = '',
	data = [],
	setIsGommeAccordionOpen,
	setIsAssicurazineRcOpen,
	setIsAssicurazioneKaskoOpen,
	setIsFurtoIncendioOpen,
	setIsVetturaSostitutivaOpen,
}: CustomToggleProps) => {
	const { setServices } = useAiContext();
	const [isChecked, setIsChecked] = useState(
		data.some((f: any) => f.isChecked)
	);
	const decoratedOnClick = useAccordionButton(eventKey);

	useEffect(() => {
		if (!isChecked) {
			setServices((prev: any) => {
				prev[flag]?.forEach((item) => (item.isChecked = false));
				return prev;
			});
		}
	}, [isChecked]);

	const setDefaultValue = (e) => {
		setServices((serv) => {
			serv = clone(serv);
			serv[flag][0].isChecked = e.target.checked;

			return serv;
		});
	};

	return (
		<div className="custom-checkbox">
			<label>
				<Form.Check
					disabled={disabled}
					type="checkbox"
					label={txtButton}
					onClick={(e) => {
						e.stopPropagation();
						decoratedOnClick(e);
					}}
					id={`custom-toggle-${eventKey}`}
					onChange={(e) => {
						setIsChecked(e.target.checked);

						switch (flag) {
							case 'gomme':
								setIsGommeAccordionOpen(e.target.checked);
								break;
							case 'assicurazioneRC':
								setIsAssicurazineRcOpen(true);
								break;
							case 'assicurazioneKasko':
								setIsAssicurazioneKaskoOpen(e.target.checked);
								break;
							case 'furtoIncendio':
								setIsFurtoIncendioOpen(e.target.checked);
								break;
							case 'vetturaSostitutiva':
								setIsVetturaSostitutivaOpen(e.target.checked);
								break;
						}

						setDefaultValue(e);
					}}
					checked={isChecked}
				/>
			</label>
		</div>
	);
};

const Services = () => {
  const [isGommeAccordionOpen, setIsGommeAccordionOpen] = useState(false);
  const [isAssicurazineRcOpen, setIsAssicurazineRcOpen] = useState(false);
  const [isAssicurazioneKaskoOpen, setIsAssicurazioneKaskoOpen] = useState(false);
  const [isFurtoIncendioOpen, setIsFurtoIncendioOpen] = useState(false);
  const [isVetturaSostitutivaOpen, setIsVetturaSostitutivaOpen] = useState(false);
  const MAX_TYRES_SET_QTY = 3

	const {
		services,
		services: {
			assicurazioneRC,
			assicurazioneKasko,
			furtoIncendio,
			gomme,
			vetturaSostitutiva,
		},
		setQuotReqState,
		setActiveStep,
		setServices,
		activeStep,
	} = useAiContext();

	const handleSubmit = (values, { setSubmitting }) => {
		if (activeStep < 2) {
			setActiveStep((prev) => prev + 1);
		}
		const checkedServices = getCheckedServices(values);

		setServices(values);
		setQuotReqState((prev) => ({ ...prev, checkedServices }));
		setSubmitting(false);
	};

	useEffect(
		() => setIsGommeAccordionOpen(gomme.some((g) => g.isChecked)),
		[gomme]
	);

	useEffect(
		() => setIsAssicurazineRcOpen(assicurazioneRC.some((g) => g.isChecked)),
		[assicurazioneRC]
	);

	useEffect(
		() =>
			setIsAssicurazioneKaskoOpen(assicurazioneKasko.some((g) => g.isChecked)),
		[assicurazioneKasko]
	);

	useEffect(
		() =>
			setIsVetturaSostitutivaOpen(vetturaSostitutiva.some((g) => g.isChecked)),
		[vetturaSostitutiva]
	);

	useEffect(() => {
		setIsFurtoIncendioOpen(furtoIncendio.some((g: any) => g.isChecked));
	}, [furtoIncendio]);

	const updateTrenoGomme = (e, values, index, type) => {
		let newValue = parseInt(e.target.value);
		if (newValue < 0) {
			newValue = 0;
		} else if (newValue > MAX_TYRES_SET_QTY) {
			newValue = MAX_TYRES_SET_QTY;
		}

		let updatedGommeOptions = [...values.gomme];
		updatedGommeOptions[index].data[type] = newValue;

		setServices((prev) => {
			prev.gomme = clone([...updatedGommeOptions]);
			return { ...prev };
		});
	};

	return (
		<div className="container">
			<Formik
				initialValues={services}
				onSubmit={handleSubmit}
				enableReinitialize={true}
			>
				{({ setFieldValue, values, handleSubmit }) => {
					return (
						<Form className="p-0" onSubmit={handleSubmit}>
							{/* <div className="display-7">Servizi</div> */}
							{/* Servizi Mobilità */}
							{/* <Card className="mt-3 mb-4 p-0">
								<Card.Body className="p-0"> */}
							<div className="fw-bold">Servizi Mobilità</div>
							{/*  Manutenzione */}
							{/* <Row>
								<Col sm={12} className="d-flex flex-column checkbox-block"> */}
							<div className="mt-3 custom-checkbox">
								<label className="">
									<Form.Check
										type="checkbox"
										name="manutenzione.isChecked"
										id="manutenzione"
										checked={values.manutenzione.isChecked}
										disabled
										onChange={(e) => {
											setFieldValue('manutenzione.isChecked', e.target.checked);
											setServices((prev) => {
												prev['manutenzione'].isChecked = e.target.checked;
												return prev;
											});
										}}
									/>
									Manutenzione
								</label>
							</div>
							{/* </Col>
							</Row> */}
							{/* Gomme */}
							<Accordion
								className="mt-2"
								activeKey={isGommeAccordionOpen ? '1' : null}
							>
								{/* <Card>
									<Card.Header> */}
								<CustomToggle
									eventKey="1"
									data={values.gomme}
									flag="gomme"
									txtButton="Gomme"
									setIsGommeAccordionOpen={setIsGommeAccordionOpen}
								>
									Gomme
								</CustomToggle>
								{/*</Card.Header> */}
								<Accordion.Collapse eventKey="1">
									{/* <Card.Body> */}
									<div>
										{gomme.map((option, index) => (
											<div
												key={index}
												className="custom-checkbox"
												style={{ marginLeft: 20, marginTop: 10 }}
											>
												<label>
													<Field
														type="radio"
														className="custom-control-input"
														name={`gomme[${index}].isChecked`}
														checked={values.gomme[index].isChecked}
														onChange={(e) => {
															let updatedGommeOptions = [...values.gomme];
															updatedGommeOptions = updatedGommeOptions.map(
																(item, idx) => ({
																	...item,
																	isChecked:
																		idx === index ? e.target.checked : false,
																})
															);

															setFieldValue('gomme', updatedGommeOptions);
															setServices((prev) => {
																prev['gomme'] = updatedGommeOptions;
																return prev;
															});
														}}
													/>
													{option.label}
												</label>
												{values.gomme[index].isChecked ? (
													<Row className="mt-3 mb-4 ms-4">
														<Col lg="auto">
															<Form.Group>
																<span>Treni Gomme estive: </span>
																<input
																	type="number"
																	className="table-input"
																	value={values.gomme[index].data.estive}
																	max={3}
																	disabled={values.gomme[index].unlimited}
																	onChange={(e) => {
																		updateTrenoGomme(
																			e,
																			values,
																			index,
																			'estive'
																		);
																	}}
																/>
															</Form.Group>
														</Col>
														<Col lg="auto">
															<Form.Group>
																<span>Treni Gomme invernali: </span>
																<input
																	type="number"
																	className="table-input"
																	value={values.gomme[index].data.invernali}
																	max={3}
																	disabled={values.gomme[index].unlimited}
																	onChange={(e) => {
																		updateTrenoGomme(
																			e,
																			values,
																			index,
																			'invernali'
																		);
																	}}
																/>
															</Form.Group>
														</Col>
														<Col lg="auto" className="d-flex">
															<Form.Group className="my-auto">
																<Form.Check
																	type="checkbox"
																	label="Gomme illimitate"
																	checked={values.gomme[index].unlimited}
																	onChange={({ target }) => {
																		let updatedGommeOptions = [...values.gomme];
																		updatedGommeOptions[index].unlimited =
																			target.checked;

																		setServices((prev) => {
																			prev = { ...prev };
																			prev.gomme = [...updatedGommeOptions];
																			return prev;
																		});
																	}}
																/>
															</Form.Group>
														</Col>
													</Row>
												) : (
													''
												)}
											</div>
										))}
									</div>
									{/* </Card.Body> */}
								</Accordion.Collapse>
								{/* </Card> */}
							</Accordion>
							{/* Vettura sostitutiva */}

							<Accordion
								className="mt-2"
								activeKey={isVetturaSostitutivaOpen ? '2' : null}
							>
								<CustomToggle
									eventKey="2"
									data={values.vetturaSostitutiva}
									flag="vetturaSostitutiva"
									txtButton="Vettura Sostitutiva"
									setIsVetturaSostitutivaOpen={setIsVetturaSostitutivaOpen}
								>
									Vettura Sostitutiva
								</CustomToggle>
								{/* </Card.Header> */}
								<Accordion.Collapse eventKey="2">
									<div>
										{/* <Card.Body> */}
										{vetturaSostitutiva.map((option, index) => {
											return (
												<div
													key={index}
													className="custom-checkbox"
													style={{ marginLeft: 20 }}
												>
													<label>
														<Field
															type="radio"
															className="custom-control-input"
															name={`vetturaSostitutiva[${index}].isChecked`}
															checked={
																values.vetturaSostitutiva[index].isChecked
															}
															onChange={(e) => {
																let updatedVetturaSosOptions = [
																	...values.vetturaSostitutiva,
																];
																updatedVetturaSosOptions =
																	updatedVetturaSosOptions.map((item, idx) => ({
																		...item,
																		isChecked:
																			idx === index ? e.target.checked : false,
																	}));
																setFieldValue(
																	'vetturaSostitutiva',
																	updatedVetturaSosOptions
																);
																setServices((prev) => {
																	prev['vetturaSostitutiva'] =
																		updatedVetturaSosOptions;
																	return prev;
																});
															}}
														/>
														{option.label}
													</label>
												</div>
											);
										})}
									</div>
									{/* </Card.Body> */}
								</Accordion.Collapse>
								{/* </Card> */}
							</Accordion>
							{/* </Card.Body>
							</Card> */}
							{/* Servizi Assicurativi */}
							{/* <Card className="mt-3 mb-4 p-0">
								<Card.Body className="p-0"> */}
							<div className="mt-4 fw-bold">Servizi Assicurativi</div>
							{/* assicurazioneRC */}
							<Row>
								<Col
									lg={6}
									className="mt-3 mb-4 d-flex flex-column checkbox-block"
								>
									<Accordion activeKey={isAssicurazineRcOpen ? '3' : null}>
										<div>
											<CustomToggle
												disabled={true}
												eventKey="3"
												data={values.assicurazioneRC}
												flag="assicurazioneRC"
												txtButton="RCA"
												setIsAssicurazineRcOpen={setIsAssicurazineRcOpen}
											>
												RCA
											</CustomToggle>
											{/* <label>
															<Form.Check
																type="checkbox"
																name="assicurazioneRC"
																id="assicurazioneRC"
																checked={true}
																disabled
															/>
															RCA
														</label> */}
											{/* </Card.Header> */}
											<Accordion.Collapse className="mt-3" eventKey="3">
												<>
													{assicurazioneRC.map((option, index) => (
														<div
															key={index}
															className="custom-checkbox"
															style={{ marginLeft: 20 }}
														>
															<label>
																<Field
																	type="radio"
																	className="custom-control-input"
																	name={`assicurazioneRC[${index}].isChecked`}
																	checked={
																		values.assicurazioneRC[index].isChecked
																	}
																	onChange={(e) => {
																		let updatedAssicurazioneRCOptions = [
																			...values.assicurazioneRC,
																		];
																		updatedAssicurazioneRCOptions =
																			updatedAssicurazioneRCOptions.map(
																				(item, idx) => ({
																					...item,
																					isChecked:
																						idx === index
																							? e.target.checked
																							: false,
																				})
																			);
																		setFieldValue(
																			'assicurazioneRC',
																			updatedAssicurazioneRCOptions
																		);
																		setServices((prev) => {
																			prev['assicurazioneRC'] =
																				updatedAssicurazioneRCOptions;
																			return prev;
																		});
																	}}
																/>
																{option.label}
															</label>
														</div>
													))}
												</>
											</Accordion.Collapse>
										</div>
									</Accordion>
								</Col>
								<Col
									lg={6}
									className="mt-3 mb-4 d-flex flex-column checkbox-block"
								>
									{/* assicurazioneKasko */}
									<Accordion activeKey={isAssicurazioneKaskoOpen ? '4' : null}>
										<div>
											<CustomToggle
												eventKey="4"
												disabled={true}
												data={values.assicurazioneKasko}
												flag="assicurazioneKasko"
												txtButton="Kasko"
												setIsAssicurazioneKaskoOpen={
													setIsAssicurazioneKaskoOpen
												}
											>
												Kasko
											</CustomToggle>
											<Accordion.Collapse className="mt-3" eventKey="4">
												<div>
													{assicurazioneKasko.map((option, index) => (
														<div
															key={index}
															className="custom-checkbox"
															style={{ marginLeft: 20 }}
														>
															<label>
																<Field
																	type="radio"
																	className="custom-control-input"
																	name={`assicurazioneKasko[${index}].isChecked`}
																	checked={
																		values.assicurazioneKasko[index].isChecked
																	}
																	onChange={(e) => {
																		let updatedAssicurazioneKaskoOptions = [
																			...values.assicurazioneKasko,
																		];
																		updatedAssicurazioneKaskoOptions =
																			updatedAssicurazioneKaskoOptions.map(
																				(item, idx) => ({
																					...item,
																					isChecked:
																						idx === index
																							? e.target.checked
																							: false,
																				})
																			);
																		setFieldValue(
																			'assicurazioneKasko',
																			updatedAssicurazioneKaskoOptions
																		);
																		setServices((prev) => {
																			prev['assicurazioneKasko'] =
																				updatedAssicurazioneKaskoOptions;
																			return prev;
																		});
																	}}
																/>
																{option.label}
															</label>
														</div>
													))}
												</div>
											</Accordion.Collapse>
										</div>
									</Accordion>
								</Col>

								<Col
									lg={6}
									className="mt-3 mb-4 d-flex flex-column checkbox-block"
								>
									{/* furtoIncendio */}
									<Accordion activeKey={isFurtoIncendioOpen ? '5' : null}>
										<div>
											{/* <Card.Header> */}
											<CustomToggle
												eventKey="5"
												disabled={true}
												data={values.furtoIncendio}
												flag="furtoIncendio"
												txtButton="Furto e Incendio"
												setIsFurtoIncendioOpen={setIsFurtoIncendioOpen}
											>
												furtoIncendio
											</CustomToggle>
											{/* </Card.Header> */}
											<Accordion.Collapse className="mt-3" eventKey="5">
												<div>
													{furtoIncendio.map((option, index) => (
														<div
															key={index}
															className="custom-checkbox"
															style={{ marginLeft: 20 }}
														>
															<label>
																<Field
																	type="radio"
																	className="custom-control-input"
																	name={`furtoIncendio[${index}].isChecked`}
																	checked={
																		values.furtoIncendio[index].isChecked
																	}
																	onChange={(e) => {
																		let updatedFurtoIncendioOptions = [
																			...values.furtoIncendio,
																		];
																		updatedFurtoIncendioOptions =
																			updatedFurtoIncendioOptions.map(
																				(item, idx) => ({
																					...item,
																					isChecked:
																						idx === index
																							? e.target.checked
																							: false,
																				})
																			);
																		setFieldValue(
																			'furtoIncendio',
																			updatedFurtoIncendioOptions
																		);
																		setServices((prev) => {
																			prev['furtoIncendio'] =
																				updatedFurtoIncendioOptions;
																			return prev;
																		});
																	}}
																/>
																{option.label}
															</label>
														</div>
													))}
												</div>
											</Accordion.Collapse>
										</div>
									</Accordion>
								</Col>
								{/* <Col
									lg={6}
									className="mt-3 mb-4 d-flex flex-column checkbox-block"
								>
									<div className="custom-checkbox">
										<label>
											<Form.Check
												type="checkbox"
												name="assicurazionePAI.isChecked"
												id="assiscurazione-pai"
												checked={values.assicurazionePAI.isChecked}
												onChange={(e) => {
													setFieldValue(
														'assicurazionePAI.isChecked',
														e.target.checked
													);
													setServices((prev) => {
														prev['assicurazionePAI'].isChecked =
															e.target.checked;
														return prev;
													});
												}}
											/>
											Assicurazione PAI
										</label>
									</div>
								</Col> */}
								<Col
									lg={6}
									className="mt-3 mb-4 d-flex flex-column checkbox-block"
								>
									{/*  tutelaLegale */}

									<div className="custom-checkbox">
										<label>
											<Form.Check
												type="checkbox"
												name="tutelaLegale.isChecked"
												id="tutela-legale-pai"
												checked={values.tutelaLegale.isChecked}
												onChange={(e) => {
													setFieldValue(
														'tutelaLegale.isChecked',
														e.target.checked
													);
													setServices((prev) => {
														prev['tutelaLegale'].isChecked = e.target.checked;
														return prev;
													});
												}}
											/>
											Tutela Legale
										</label>
									</div>
								</Col>
							</Row>
							{/* </Card.Body>
							</Card> */}
						</Form>
					);
				}}
			</Formik>
		</div>
	);
};

export default Services;
